import { render, staticRenderFns } from "./directWebManage.vue?vue&type=template&id=a3ac2cbc&scoped=true"
import script from "./directWebManage.vue?vue&type=script&lang=js"
export * from "./directWebManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ac2cbc",
  null
  
)

export default component.exports